import React from 'react';

const PrintFooter = () => {
  return (
    <>
      {/* start - Footer */}
      <footer className="" id="footer">
        <div className="container-fluid">
          <div className="">© 2025 جميع الحقوق محفوظة لوزارة الصحة و السكان المصرية - Ver 16.1</div>
          <div className="images">
            <img src="/assets/images/AstraLogo.png" width="100" height="30" alt="Astrazaneca" />
            <img src="/assets/images/RocheLogo.png" width="80" height="50" alt="Roche" />
            <img src="/assets/images/BgpLogo.png" width="100" height="60" alt="Bgp" />
          </div>
          <div className="">
            <a href="http://www.dmsegypt.net" target="_blank" rel="noopener noreferrer">
              <img src="/assets/images/logo-dms.png" width="61" height="20" alt="DMS Egypt" />
            </a> Developed by
          </div>
          <div className="clearfix"></div>
        </div>
      </footer>
      <div className="load"></div>
      {/* End - Footer */}
    </>
  );
};

export default PrintFooter;
